export default __webpack_public_path__ + "static/media/finished.513a8565.svg";